<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="true" :crubList="[{name:'孵化器管理'},{name:'入驻企业'}]" :title="'入驻企业'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">提交日期</span>
                       <el-date-picker
                           size="small"
                           v-model="sendInfoOne.time"
						   format="yyyy-MM-dd"
						    value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" 
							:default-time="['24:00:00','23:59:59']"
                           range-separator="至"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                       </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                   <!-- <el-button type="primary" size="small"
                               v-if="authorities.indexOf('sys:permission:background:enterprise:list:button:download') != -1" 
							   @click="downLoad">下载</el-button> -->
                    <el-button type="primary" size="small"
                      v-if="authorities.indexOf('sys:permission:background:enterprise:list:button:delete') != -1" 
					  @click="del">
					  删除
					  </el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
				        :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    
                    width="55">
                </el-table-column>
               <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="文件ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="fileName"
                    show-overflow-tooltip
                    
                    label="文件名称">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
					sortable
                    label="提交时间">
                </el-table-column>
				<el-table-column
					v-if="authorities.indexOf('sys:permission:background:enterprise:list:button:download') != -1"
				    label="操作"
				    
				    width="100">
				    <template slot-scope="scope">
						<el-button size="small" type="primary" class="super" plain 
						   @click="downLoad(scope.row)"
						>下载</el-button>
				    </template>
				</el-table-column>
            </el-table>
           <!-- 分页 -->
           <div class="pagination" ref="pagination">
           	<Paging
           	:PageData="PageData"
           	v-if="tableData.length>0"
           	@nextpage="nextpage"
           	@previouspage="previouspage"
           	@handleSizeChange="handleSizeChange"
           	@handleCurrentChange="handleCurrentChange"
           	></Paging>
           </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {onDownload} from "@/utils/common";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
					value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }],//检索下拉
            tableData:[],//表格数据
            multipleSelection: [],//表格多选结果数组
			sendInfoOne:{
			    time:"",//提交日期
			    drop:'',//检索选择值
			    dropValue:'',//检索输入值
			},//检索提交数据
            sendInfo:{
            	currentPage:1,//当前页
            	pageSize:10,//页条数
            	property:null,//排序字段
            	direction: 'DESC', //排序排序方式DESC降 ASC升
            	endDate:null,//结束时间
            	startDate:null,//开始时间
            	id:null,//文件ID
            	name:null,//姓名
            	userName:null,//账号
            },
            PageData:{
              currentPage: 0,
              total: 0, //多少條
            },
            dataInfo:'',//详细信息
        }
    },
	created() {
		this.getList()
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfo.property=prop;
            this.sendInfo.direction=order;
            this.getList()
        },
      onReset(){
        const param = {
          currentPage:1,//当前页
            	pageSize:10,//页条数
            	property:null,//排序字段
            	direction: 'DESC', //排序排序方式DESC降 ASC升
            	endDate:null,//结束时间
            	startDate:null,//开始时间
            	id:null,//文件ID
            	name:null,//姓名
            	userName:null,//账号
        }
        this.sendInfo = Object.assign(this.sendInfo,param)
        const aa = {
           time:"",//提交日期
			    drop:'',//检索选择值
			    dropValue:'',//检索输入值
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,aa)
        if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
        this.retrieval()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/entered/company/list',{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //检索事件
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0]
				this.sendInfo.endDate=lookData.time[1]
			}else{
				this.sendInfo.startDate=null
				this.sendInfo.endDate=null
			}
			this.sendInfo.id=null;
			this.sendInfo.name=null;
			this.sendInfo.userName=null;
			let lookdell=lookData.drop;
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
			}else if(lookdell==2){
				this.sendInfo.userName=lookData.dropValue;
			}else if(lookdell==3){
				this.sendInfo.name=lookData.dropValue;
			}
			this.getList();
		},
        //表格选择事件
        handleSelectionChange(val) {
			if(!val)return;
			this.multipleSelection=''
			val.forEach(val => {
				this.multipleSelection+=val.id+',';
			});
        },
        //批量下载
        downLoad:function({filePath,fileName}){
            // this.multipleSelection
			      // window.open(url)
            const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //批量删除
        del:function(){
			if(this.multipleSelection==''){
				return
			}
            this.$confirm('确认删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    // this.multipleSelection
					let list ={
						list :this.multipleSelection
					}
					this.$axiosc.delete('/backstage/entered/company/delList',{params:list}).then((r)=>{
					    if(r.code==200){
					        this.$message({
					            type: 'success',
					            message: '删除成功!'
					        });
					        this.getList();
					    }else{
					        this.$alert(r.msg);
					    }
					})
                  
                }).catch(() => {    
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
			this.sendInfo.currentPage=val;
			this.sendInfo.currentPage = val;
			this.getList()
        },
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>